import { Injectable, inject } from '@angular/core';
import { InvestigationTypeState } from '../../states/investigation-type.state';

@Injectable({ providedIn: 'root' })
export class SetInvestigationTypeActiveInStateUseCase {
  private readonly _state = inject(InvestigationTypeState);

  public execute(id: string, isActive: boolean): void {
    const investigationTypes = this._state.investigationTypes();
    const investigationType = investigationTypes.find((it) => it.id === id);

    if (!investigationType) {
      return;
    }

    const updatedInvestigationType = { ...investigationType, isActive };
    this._state.updateInvestigationType(updatedInvestigationType);
  }
}
